import { render, staticRenderFns } from "./V3Popup.vue?vue&type=template&id=e904ebc8&scoped=true&"
import script from "./V3Popup.vue?vue&type=script&lang=js&"
export * from "./V3Popup.vue?vue&type=script&lang=js&"
import style0 from "./V3Popup.vue?vue&type=style&index=0&id=e904ebc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e904ebc8",
  null
  
)

export default component.exports